import { styled } from '@mui/material/styles';
import { verifyAuthPermission } from '../../auth/VerifyAuthPermission';
import { AuthPermissions } from '../../auth/AuthPermissions';
import { useLocalStorage } from '../../utils/useLocalStorage';
import { CustomSupportEmailCard } from './OrganizationSettings/CustomSupportEmailCard';
import { HomeCountryConfigurationCard } from './OrganizationSettings/HomeCountryConfigurationCard';
import { useFetchService } from '../../utils/fetchService';
import { orgHasLicense } from '../Organization/org-utils';

export function OrganizationSettings() {
  const [accessToken = ''] = useLocalStorage('accessToken', '');

  const canUpdateOrg = verifyAuthPermission(AuthPermissions.UPDATE_ORG);

  const useOrganization = (accessToken: string, shouldFetch = true) => {
    const { data: orgData, error: organizationError, mutate } = useFetchService(`/organizations/`, accessToken, shouldFetch);
    const isLoading = !orgData && !organizationError;
    return { orgData, organizationError, isLoading, mutate };
  };

  const { orgData, organizationError, isLoading, mutate } = useOrganization(accessToken);
  if (organizationError) return <div>failed to load</div>;
  if (isLoading || !orgData) return <div>loading...</div>;
  const isPdmLicense = orgHasLicense(orgData, 'pdm-integration');

  return (
    <StyledCardContainer>
      {isPdmLicense && <CustomSupportEmailCard isAdmin={canUpdateOrg} currentSupportEmail={orgData.supportEmail} mutate={mutate} />}
      <HomeCountryConfigurationCard isAdmin={canUpdateOrg} currentHomeCountry={orgData.homeCountryCode} mutate={mutate} />
    </StyledCardContainer>
  );
}

const StyledCardContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 0.5fr);
  gap: 1rem;
  width: 100%;
`;
